import { AMENDMENT_REASONS } from '_constants/amendment';
import { FIELD_KEYS, MONTH_OPTIONS, RELATIONSHIP_OPTIONS, STATE_OPTIONS } from '_constants/forms';
import { TRANSACTION_TYPES } from '_constants/transactions';
import { getValidationRules } from '_helpers/forms/rules';

const fieldProps = {
  [FIELD_KEYS.firstName]: {
    name: FIELD_KEYS.firstName,
    label: 'First Name',
    placeholder: 'Enter First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.lastName]: {
    name: FIELD_KEYS.lastName,
    label: 'Last Name',
    placeholder: 'Enter Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.username]: {
    name: FIELD_KEYS.username,
    required: true,
    label: 'Username / E-mail Address',
    placeholder: 'Your Username / E-mail Address',
  },
  [FIELD_KEYS.dateOfBirth]: {
    name: FIELD_KEYS.dateOfBirth,
    required: true,
    label: 'Birthday',
    placeholder: 'Select Date',
  },
  [FIELD_KEYS.ssn]: {
    name: FIELD_KEYS.ssn,
    required: true,
    label: 'SSN',
    mask: '000-00-0000',
    placeholder: '000-00-0000',
  },
  [FIELD_KEYS.phone]: {
    name: FIELD_KEYS.phone,
    required: true,
    type: 'phone',
    mask: '(000) 000-0000',
    label: 'Phone',
    placeholder: '(123) 456-7890',
  },
  [FIELD_KEYS.email]: {
    name: FIELD_KEYS.email,
    required: true,
    type: 'email',
    label: 'Email',
    placeholder: 'Enter Email',
  },
  [FIELD_KEYS.address1]: {
    name: FIELD_KEYS.address1,
    required: true,
    label: 'Address',
    placeholder: 'Enter Address',
  },
  [FIELD_KEYS.city]: {
    name: FIELD_KEYS.city,
    required: true,
    label: 'City',
    placeholder: 'Enter City',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.state]: {
    name: FIELD_KEYS.state,
    required: true,
    label: 'State',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELD_KEYS.zip]: {
    name: FIELD_KEYS.zip,
    required: true,
    label: 'ZIP Code',
    placeholder: 'Enter ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.password]: {
    name: FIELD_KEYS.password,
    required: true,
    type: 'password',
    label: 'Password',
    placeholder: 'Your Password',
  },
  [FIELD_KEYS.oldPassword]: {
    name: FIELD_KEYS.oldPassword,
    required: true,
    type: 'password',
    label: 'Current Password',
    placeholder: 'Your Password',
  },
  [FIELD_KEYS.newPassword]: {
    name: FIELD_KEYS.newPassword,
    required: true,
    type: 'password',
    label: 'New Password',
    placeholder: 'Your Password',
  },
  [FIELD_KEYS.confirmation]: {
    name: FIELD_KEYS.confirmation,
    required: true,
    type: 'password',
    label: 'Confirm New Password',
    placeholder: 'Your Confirmation',
  },
  [FIELD_KEYS.startDate]: {
    name: FIELD_KEYS.startDate,
    required: true,
    label: 'Start Date',
    placeholder: 'Select Start Date',
  },
  [FIELD_KEYS.endDate]: {
    name: FIELD_KEYS.endDate,
    required: true,
    label: 'End Date',
    placeholder: 'Select End Date',
  },
  [FIELD_KEYS.description]: {
    name: FIELD_KEYS.description,
    required: true,
    label: 'Description',
    placeholder: 'Enter Description',
  },
  [FIELD_KEYS.file]: {
    name: FIELD_KEYS.file,
    required: true,
    type: 'file',
    label: 'File',
    placeholder: 'Choose file',
  },
  [FIELD_KEYS.cardNumber]: {
    name: FIELD_KEYS.cardNumber,
    required: true,
    label: 'Card Number',
    placeholder: '0000 0000 0000 0000',
  },
  [FIELD_KEYS.cvc]: {
    name: FIELD_KEYS.cvc,
    type: 'password',
    required: true,
    label: 'CVC/CVV',
    placeholder: 'CVC',
    maxLength: '4',
    onKeyPress: (event) => {
      if (!/[\d{3,4}]/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  [FIELD_KEYS.cardMonth]: {
    name: FIELD_KEYS.cardMonth,
    required: true,
    label: 'Expiration date / Month',
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELD_KEYS.cardYear]: {
    name: FIELD_KEYS.cardYear,
    required: true,
    label: 'Expiration date / Years',
    placeholder: 'Year',
  },
  [FIELD_KEYS.returnToAmend]: {
    name: FIELD_KEYS.returnToAmend,
    required: true,
    label: 'Select a return to amend',
    placeholder: 'Select Choice',
    options: [],
  },
  [FIELD_KEYS.reasonForAmendment]: {
    name: FIELD_KEYS.reasonForAmendment,
    required: true,
    label: 'Select reason for amendment',
    placeholder: 'Select Choice',
    options: [
      { title: 'Error', value: AMENDMENT_REASONS.Error },
      { title: 'Missed Deduction', value: AMENDMENT_REASONS.MissedDeduction },
      { title: 'Missed Income Form', value: AMENDMENT_REASONS.MissedIncomeForm },
      { title: 'Other', value: AMENDMENT_REASONS.Other },
    ],
  },
  [FIELD_KEYS.fileType]: {
    name: FIELD_KEYS.fileType,
    required: true,
    label: 'Document Type',
    placeholder: 'Select Document Type',
    options: [],
  },
  [FIELD_KEYS.tags]: {
    name: FIELD_KEYS.tags,
    required: true,
    label: 'Tags',
    placeholder: 'Start enter tags',
  },
  [FIELD_KEYS.accountName]: {
    name: FIELD_KEYS.accountName,
    required: true,
    label: 'Category',
    placeholder: 'Enter New or select Category',
  },
  [FIELD_KEYS.contactName]: {
    name: FIELD_KEYS.contactName,
    required: true,
    label: 'Contact Name',
    placeholder: 'Enter Contact Name',
  },
  [FIELD_KEYS.total]: {
    name: FIELD_KEYS.total,
    required: true,
    label: 'Amount',
    placeholder: 'Enter Amount',
    mask: '$num',
    blocks: {
      num: {
        mask: Number,
        radix: '.',
        thousandsSeparator: ',',
      },
    },
  },
  [FIELD_KEYS.reference]: {
    name: FIELD_KEYS.reference,
    required: true,
    label: 'Reference',
    placeholder: 'Select Reference',
    options: [
      { title: 'NOTE', value: 'NOTE' },
      { title: 'DEPOSIT', value: 'DEPOSIT' },
      { title: 'POSDEBIT', value: 'POSDEBIT' },
      { title: 'TRANSFER', value: 'TRANSFER' },
    ],
  },
  [FIELD_KEYS.transactionType]: {
    name: FIELD_KEYS.transactionType,
    required: true,
    label: 'Type',
    placeholder: 'Select Type',
    options: [
      { title: TRANSACTION_TYPES.receive, value: TRANSACTION_TYPES.receive },
      { title: TRANSACTION_TYPES.spend, value: TRANSACTION_TYPES.spend },
    ],
  },
  [FIELD_KEYS.date]: {
    name: FIELD_KEYS.date,
    required: true,
    label: 'Date',
    placeholder: 'Select Date',
  },
  [FIELD_KEYS.reconcile]: {
    name: FIELD_KEYS.reconcile,
    label: 'Reconcile',
  },
  [FIELD_KEYS.spouse]: {
    name: FIELD_KEYS.spouse,
    required: true,
    label: 'Have a spouse?',
    placeholder: 'Select Option',
    options: [
      { title: 'No', value: 'no' },
      { title: 'Yes', value: 'yes' },
    ],
  },
  [FIELD_KEYS.spouseFirstName]: {
    name: FIELD_KEYS.spouseFirstName,
    label: 'Spouse First Name',
    placeholder: 'Enter Spouse First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.spouseLastName]: {
    name: FIELD_KEYS.spouseLastName,
    label: 'Spouse Last Name',
    placeholder: 'Enter Spouse Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.spouseDateOfBirth]: {
    name: FIELD_KEYS.spouseDateOfBirth,
    required: true,
    label: 'Spouse Birthday',
    placeholder: 'Select Date',
  },
  [FIELD_KEYS.spouseSsn]: {
    name: FIELD_KEYS.spouseSsn,
    required: true,
    label: 'Spouse SSN',
    mask: '000-00-0000',
    placeholder: '000-00-0000',
  },
  [FIELD_KEYS.spousePhone]: {
    name: FIELD_KEYS.spousePhone,
    required: false,
    type: 'phone',
    mask: '(000) 000-0000',
    label: 'Spouse Phone',
    placeholder: '(123) 456-7890',
  },
  [FIELD_KEYS.spouseEmail]: {
    name: FIELD_KEYS.spouseEmail,
    required: false,
    type: 'email',
    label: 'Spouse Email',
    placeholder: 'Enter Spouse Email',
  },
  [FIELD_KEYS.spouseAddress1]: {
    name: FIELD_KEYS.spouseAddress1,
    required: true,
    label: 'Spouse Address',
    placeholder: 'Enter Spouse Address',
  },
  [FIELD_KEYS.spouseCity]: {
    name: FIELD_KEYS.spouseCity,
    required: true,
    label: 'Spouse City',
    placeholder: 'Enter Spouse City',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.spouseState]: {
    name: FIELD_KEYS.spouseState,
    required: true,
    label: 'Spouse State',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELD_KEYS.spouseZip]: {
    name: FIELD_KEYS.spouseZip,
    required: true,
    label: 'Spouse ZIP Code',
    placeholder: 'Enter Spouse ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELD_KEYS.marriedFilingSeparately]: {
    name: FIELD_KEYS.marriedFilingSeparately,
    required: true,
    label: 'Filing Status',
    options: [
      {
        title: 'Married Filing Jointly',
        value: 'jointly',
      },
      {
        title: 'Married Filing Separately',
        value: 'separately',
      },
    ],
  },
  [FIELD_KEYS.filingSingle]: {
    name: FIELD_KEYS.filingSingle,
    required: true,
    label: 'Filing Status',
    options: [
      {
        title: 'Head of Household',
        value: 'household',
      },
      {
        title: 'Filing Single',
        value: 'single',
      },
    ],
  },
  [FIELD_KEYS.year]: {
    name: FIELD_KEYS.year,
    required: true,
    label: 'Year',
    placeholder: 'Select Year',
  },
  [FIELD_KEYS.response]: {
    name: FIELD_KEYS.response,
    required: true,
    label: 'Your Response',
    placeholder: 'Enter message',
  },
  [FIELD_KEYS.relationship]: {
    name: FIELD_KEYS.relationship,
    required: true,
    label: 'Relationship to You',
    placeholder: 'Select Relationship',
    options: RELATIONSHIP_OPTIONS,
  },
};

export const getFieldProps = (fieldKey, { validationOptions } = {}) => {
  const props = fieldProps[fieldKey];
  return props ? { ...props, rules: getValidationRules(fieldKey, validationOptions) } : {};
};
